'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogRegistrationRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogRegistrationRemote = exports.CatalogRegistrationRemote = {
    fetchCatalogRegistration: function fetchCatalogRegistration(_ref) {
        var Token = _ref.authToken,
            AuctionId = _ref.catalogId,
            deployment = _ref.deployment,
            Email = _ref.email,
            Source = _ref.source;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                authToken: Token,
                deployment: deployment,
                path: '<CLERK-SERVICE>clerk/approval/' + AuctionId
            });
            request.send({
                AuctionId: AuctionId,
                Email: Email,
                Source: Source,
                Token: Token
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, success404: true });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/catalogRegistration.js
// module id = yTM5
// module chunks = 60